'use strict';
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// === init TS search client
class TSBlogWidget {
    constructor(per_page) {
        this.init = () => __awaiter(this, void 0, void 0, function* () {
            yield this.initQuery();
            this.updateTags(this.currentState);
            this.getSearchBarVal();
            this.getCategorySelectVal();
            this.getSortByVal();
            this.getPageL();
            this.getPageR();
            this.getTagsVal();
            this.renderPageNumber(this.currentState);
            // this.updateDocuments(this.currentState)
        });
        this.getSearchBarVal = () => {
            const searchBar = document.getElementById('blogSearchBar');
            searchBar === null || searchBar === void 0 ? void 0 : searchBar.addEventListener('input', () => __awaiter(this, void 0, void 0, function* () {
                this.currentState.query = searchBar.value;
                const refactorySearchOn = yield this.triggerTimer(this.currentState, 1500);
                if (refactorySearchOn) {
                    this.resetPage();
                    this.evoke(this.currentState);
                }
            }));
        };
        this.getCategorySelectVal = () => {
            const selectElm = document.getElementById('blog_category');
            selectElm === null || selectElm === void 0 ? void 0 : selectElm.addEventListener('input', () => {
                this.currentState.category = selectElm.value;
                this.currentState.tag = undefined;
                this.resetPage();
                this.evoke(this.currentState);
            });
        };
        this.getSortByVal = () => {
            const sortByWrapper = document.querySelector('.sortBy__container');
            const inputElms = sortByWrapper === null || sortByWrapper === void 0 ? void 0 : sortByWrapper.querySelectorAll("input");
            inputElms.forEach((el, ind) => {
                el.addEventListener("input", () => {
                    if (el.checked) {
                        this.currentState.sortBy = el.value;
                    }
                    else {
                        this.currentState.sortBy = undefined;
                    }
                    this.evoke(this.currentState);
                    inputElms.forEach((el_01, ind_01) => {
                        if (ind_01 !== ind) {
                            el_01.checked = false;
                        }
                    });
                });
            });
        };
        this.getPageL = () => {
            const left = document.getElementById("pageSelect--collection__container__left");
            left === null || left === void 0 ? void 0 : left.addEventListener("click", () => {
                let curPage = this.currentState.page;
                if (curPage > 1) {
                    curPage = curPage - 1;
                    this.currentState.page = curPage;
                    this.evoke(this.currentState);
                }
            });
        };
        this.getPageR = () => {
            const right = document.getElementById("pageSelect--collection__container__right");
            right === null || right === void 0 ? void 0 : right.addEventListener("click", () => {
                let curPage = this.currentState.page;
                const maxPage = 10;
                if (curPage < this.currentState.maxPage) {
                    curPage = curPage + 1;
                    this.currentState.page = curPage;
                    this.evoke(this.currentState);
                }
            });
        };
        this.getTagsVal = () => {
            const tagsWrapper = document.getElementById("facet_filters_wrapper");
            const tagElms = tagsWrapper === null || tagsWrapper === void 0 ? void 0 : tagsWrapper.querySelectorAll("input");
            if (!tagElms)
                return;
            tagElms.forEach((el, ind) => {
                el.addEventListener("input", () => {
                    this.currentState.tag = undefined;
                    if (el.checked === true) {
                        this.currentState.tag = el.value;
                    }
                    this.resetPage();
                    this.evoke(this.currentState);
                    tagElms.forEach((el_01, ind_01) => {
                        if (ind_01 !== ind) {
                            el_01.checked = false;
                        }
                    });
                });
            });
        };
        // DOM
        this.createTagButton = (value, id, innerText, count) => {
            const wrapper = document.createElement('div');
            const input = document.createElement('input');
            const label = document.createElement('label');
            const span = document.createElement('span');
            Object.assign(input, { type: "checkbox", value, id });
            Object.assign(label, { htmlFor: id, innerText: `${innerText} (${count})` });
            // Object.assign(span, { innerText: JSON.stringify(count) })
            MoobiUtilities.bulkInsertElm(wrapper, [input, label, span]);
            // MoobiUtilities.bulkInsertElm(wrapper, [input, label, span])
            return wrapper;
        };
        this.insertTagButtons = (button) => {
            const wrapper = document.getElementById("facet_filters_wrapper");
            wrapper.insertAdjacentElement("beforeend", button);
        };
        this.clearTagButtons = () => {
            const wrapper = document.getElementById("facet_filters_wrapper");
            wrapper.innerHTML = '';
        };
        this.selectChosenTag = (state) => {
            const tagsWrapper = document.getElementById('facet_filters_wrapper');
            const tags = tagsWrapper === null || tagsWrapper === void 0 ? void 0 : tagsWrapper.querySelectorAll('input');
            tags === null || tags === void 0 ? void 0 : tags.forEach((el) => {
                if (el.value === state.tag) {
                    el.checked = true;
                }
            });
        };
        this.updateTags = (currentState) => {
            this.clearTagButtons();
            currentState.tags.forEach((el) => {
                const button = this.createTagButton(el.value, `facet_button_${el.value}`, el.value, el.count);
                this.insertTagButtons(button);
            });
            this.selectChosenTag(currentState);
        };
        this.updateDocuments = (currentState) => {
            if (currentState.result.length < 1) {
                this.renderNotFound();
                this.renderPageNumber(currentState);
            }
            if (currentState.result.length >= 1) {
                this.renderDocuments(currentState);
                this.renderPageNumber(currentState);
            }
        };
        this.renderDocuments = (currentState) => {
            const documentsWrapper = document.getElementById('response');
            const removeTextSkeleton = (elm) => {
                elm.classList.remove("textSkeleton");
            };
            documentsWrapper.innerHTML = "";
            currentState.result.forEach((el) => {
                const getBlogHandle = (id) => {
                    const map = {
                        81470783671: "wisdom-car-beauty",
                        81471045815: "wisdom-startup",
                        81470161079: "wisdom-repairs",
                        83330367738: "car-repairs-tutorial",
                    };
                    const handle = map[id];
                    return handle;
                };
                const blogHandle = getBlogHandle(el.document.blog_id);
                const articleHandle = el.document.handle;
                const date = new Date(el.document.created_at);
                const template = `<div class="featuredArticle_card" data-homepage_engagement_type="homePage_article_standard">
            <a href="/blogs/${blogHandle}/${articleHandle}">
              <div class="imageWrapper imageSkeleton"><img loading="lazy" src="${el.document["image.src"]}"></div>
            </a>
            <div class="featuredArticle_contentWrapper">
              <h6 data-type="article_title" class="h6main">${el.document.title}</h6>
              <p data-type="article_published_at" class="paragraph02L">${date.toLocaleDateString('en-US', {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                })}</p>
            </div>
          </div>`;
                documentsWrapper.insertAdjacentHTML('beforeend', template);
                const textElms = documentsWrapper.querySelectorAll(".textSkeleton");
                textElms.forEach((el) => {
                    removeTextSkeleton(el);
                });
            });
        };
        this.renderLoading = () => {
            const documentsWrapper = document.getElementById('response');
            documentsWrapper.innerHTML = "";
            const template = `<div class="featuredArticle_card" data-homepage_engagement_type="homePage_article_standard">
            <a href="">
              <div class="imageWrapper imageSkeleton"></div>
            </a>
            <div class="featuredArticle_contentWrapper">
              <h6 data-type="article_title" class="h6main textSkeleton"></h6>
              <p data-type="article_published_at" class="paragraph02L textSkeleton"></p>
            </div>
          </div>`;
            for (let i = 0; i < 5; i++) {
                documentsWrapper.insertAdjacentHTML('beforeend', template);
            }
        };
        this.renderNotFound = () => {
            const documentsWrapper = document.getElementById('response');
            documentsWrapper.innerHTML = "";
            const notFoundMsg = document.createElement('h4');
            notFoundMsg.innerText = "無相關文章，請嘗試其他關鍵字。";
            notFoundMsg.classList.add("paragraph01");
            documentsWrapper.insertAdjacentElement("beforeend", notFoundMsg);
        };
        this.renderPageNumber = (currentState) => {
            const pageNumber = document.getElementById('currentPageNumber');
            pageNumber ? pageNumber.innerText = JSON.stringify(currentState.page) : "";
            const left = document.getElementById("pageSelect--collection__container__left");
            const right = document.getElementById("pageSelect--collection__container__right");
            currentState.page === currentState.maxPage ? right === null || right === void 0 ? void 0 : right.classList.add("inactive") : right === null || right === void 0 ? void 0 : right.classList.remove("inactive");
            currentState.page === 1 ? left === null || left === void 0 ? void 0 : left.classList.add("inactive") : left === null || left === void 0 ? void 0 : left.classList.remove("inactive");
        };
        // helpers
        this.triggerTimer = (stateWhenCalled, duration) => __awaiter(this, void 0, void 0, function* () {
            const prevQ = stateWhenCalled.query;
            const timer = new Promise((resolve, reject) => {
                setTimeout(() => {
                    if (prevQ === this.currentState.query) {
                        resolve(true);
                        return true;
                    }
                    else {
                        resolve(false);
                        return false;
                    }
                }, duration);
            });
            return timer;
        });
        // when called start a timer,
        // when called again return false, restart timer
        // 
        // query
        this.formateQueryString = (currentState) => {
            const blogIDfilterString = (currentState === null || currentState === void 0 ? void 0 : currentState.category) ? `blog_id:=${currentState === null || currentState === void 0 ? void 0 : currentState.category}` : '';
            const tagsFilterString = (currentState === null || currentState === void 0 ? void 0 : currentState.tag) ? `tags:=[${currentState === null || currentState === void 0 ? void 0 : currentState.tag}]` : '';
            const filterString = ((strings) => {
                const trueStrings = strings.filter((el) => { return !!el; });
                return trueStrings.join("&&");
            })([blogIDfilterString, tagsFilterString]);
            console.log(filterString);
            let searchParameters = {
                q: (currentState === null || currentState === void 0 ? void 0 : currentState.query) ? `${currentState === null || currentState === void 0 ? void 0 : currentState.query}` : ``,
                query_by: 'title',
                facet_by: `blog_id,tags`,
                max_facet_values: 8,
                filter_by: `${filterString} ${filterString ? "&&" : ""} blog_id: [81470783671, 81471045815, 81470161079, 83330367738]`,
                // filter_by: currentState?.category ? `blog_id:=${currentState?.category}` : '',
                sort_by: (currentState === null || currentState === void 0 ? void 0 : currentState.sortBy) || 'created_at:desc',
                per_page: this.currentState.per_page,
                page: (currentState === null || currentState === void 0 ? void 0 : currentState.page) ? currentState === null || currentState === void 0 ? void 0 : currentState.page : 1,
                exclude_fields: 'bodyHTML'
            };
            console.log(searchParameters);
            return searchParameters;
        };
        this.formateVecQueryString = (embedding, currentState, distanceCutOff) => {
            const blogIDfilterString = (currentState === null || currentState === void 0 ? void 0 : currentState.category) ? `blog_id:=${currentState === null || currentState === void 0 ? void 0 : currentState.category}` : '';
            const tagsFilterString = (currentState === null || currentState === void 0 ? void 0 : currentState.tag) ? `tags:=[${currentState === null || currentState === void 0 ? void 0 : currentState.tag}]` : '';
            const filterString = ((strings) => {
                const trueStrings = strings.filter((el) => { return !!el; });
                return trueStrings.join("&&");
            })([blogIDfilterString, tagsFilterString]);
            // console.log(currentState?.sortBy)
            let searchRequests = {
                'searches': [
                    {
                        collection: "shopify_articles_zh_vec",
                        facet_by: `blog_id,tags`,
                        q: '*',
                        filter_by: `${filterString} ${filterString ? "&&" : ""} blog_id: [81470783671, 81471045815, 81470161079, 83330367738]`,
                        flat_search_cutoff: 20,
                        vector_query: `vec:([${embedding.join(',')}], distance_threshold:${distanceCutOff}, k:100)`,
                        exclude_fields: 'vec',
                        per_page: this.currentState.per_page,
                        page: (currentState === null || currentState === void 0 ? void 0 : currentState.page) ? currentState === null || currentState === void 0 ? void 0 : currentState.page : 1,
                        sort_by: (currentState === null || currentState === void 0 ? void 0 : currentState.sortBy) || "_vector_distance:asc"
                    }
                ]
            };
            return searchRequests;
        };
        this.queryTS = (searchParams) => __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield moobiTypeSenseClient.collections('shopify_articles_zh_vec').documents().search(searchParams);
                // console.log(res)
                return res;
            }
            catch (error) {
                console.log(error);
            }
        });
        this.queryMultiTS = (searchRequests) => __awaiter(this, void 0, void 0, function* () {
            try {
                let commonSearchParams = {};
                const res = yield moobiTypeSenseClient.multiSearch.perform(searchRequests, commonSearchParams);
                return res;
            }
            catch (error) {
                console.log(error);
            }
        });
        this.updateTagsState = (res) => {
            this.currentState.tags = [];
            const facet_counts = (res === null || res === void 0 ? void 0 : res.facet_counts) ? res.facet_counts : res.results[0].facet_counts;
            const tags = facet_counts.filter((el) => {
                if ((el === null || el === void 0 ? void 0 : el.field_name) === "tags") {
                    return true;
                }
            });
            tags[0].counts.forEach((el) => { this.currentState.tags.push(el); });
            return this.currentState.tags;
        };
        this.updateMaxPage = (found, per_page) => {
            this.currentState.maxPage = Math.ceil(found / per_page);
        };
        this.initQuery = () => __awaiter(this, void 0, void 0, function* () {
            let searchParameters = {
                q: ``,
                query_by: 'title',
                facet_by: `blog_id,tags`,
                max_facet_values: 5,
                filter_by: '',
                sort_by: 'created_at:desc',
                per_page: this.currentState.per_page,
                page: 1,
                exclude_fields: 'bodyHTML'
            };
            const res = yield this.queryTS(searchParameters);
            const results = res.hits;
            const found = res.found;
            this.setResults(results);
            this.updateTagsState(res);
            this.updateMaxPage(found, searchParameters.per_page);
        });
        this.getEmbeddings = (query) => __awaiter(this, void 0, void 0, function* () {
            if (!query)
                return undefined;
            if (query) {
                const embedding = yield moobiQueries.getEmbeddings(query);
                // console.log(embedding)
                return embedding;
            }
        });
        this.setResults = (results) => {
            console.log(results);
            this.currentState.result = [];
            results.forEach((el) => { this.currentState.result.push(el); });
            // console.log(this.currentState.result)
        };
        this.resetPage = () => {
            this.currentState.page = 1;
        };
        this.evoke = (currentState) => __awaiter(this, void 0, void 0, function* () {
            this.renderLoading();
            const embeddings = yield this.getEmbeddings(currentState.query);
            if (!embeddings) {
                const searchParams = this.formateQueryString(currentState);
                const res = yield this.queryTS(searchParams);
                const results = res.hits;
                this.setResults(results);
                this.updateTagsState(res);
                const found = res.found;
                this.updateMaxPage(found, this.currentState.per_page);
                this.updateTags(this.currentState);
                this.getTagsVal();
                this.updateDocuments(this.currentState);
            }
            if (embeddings) {
                const searchParams = this.formateVecQueryString(embeddings.data, currentState, 0.7);
                console.log(searchParams);
                const res = yield this.queryMultiTS(searchParams);
                console.log(res);
                const results = res.results[0].hits;
                // const filteredResults = results.filter((el: VecArticleDataItem) => {
                //     if (el.vector_distance > 0.8) { return false } else { return true }
                // })
                this.setResults(results);
                this.updateTagsState(res);
                const found = res.results[0].found;
                // console.log(found)
                this.updateMaxPage(found, this.currentState.per_page);
                this.updateTags(this.currentState);
                this.getTagsVal();
                this.updateDocuments(this.currentState);
            }
        });
        this.initState = {
            query: undefined,
            category: undefined,
            sortBy: undefined,
            page: 1,
            maxPage: 10,
            tag: undefined,
            queryTimeUp: false,
            per_page: per_page,
            result: [],
            tags: []
        };
        this.currentState = JSON.parse(JSON.stringify(this.initState));
        this.init();
    }
}
const tsBlogWidget = new TSBlogWidget(6);
